const lightModeColors = {
  type: 'light-mode',
  background: '#EBEBEB',
  mainColor: '#36C8D8',
  cardColor: '#FFFFFF',
  disableColor: '#D94C20',
  fontColor: '#4B4B4B',
};

const darkModeColors = {
  type: 'dark-mode',
  background: '#4B4B4B',
  mainColor: '#36C8D8',
  cardColor: '#343434',
  disableColor: '#D94C20',
  fontColor: '#EBEBEB',
};

const CHAT_URL = 'http://localhost:8000';

const limitOfArticles = 100;

export { lightModeColors, darkModeColors, CHAT_URL, limitOfArticles };
